export enum MarketingAccountTypeEnum {
    EMAIL = 'EMAIL',
    SMS = 'SMS'
}
